import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

/**
 * IPsec Proposal catalog entry (CloudZiti V8 / V3 API).
 *
 * Server-managed catalog of supported IKE and ESP cipher proposals. Each
 * IpsecTunneler may select a subset of the catalog (per type) to use; when
 * no selection is made, the server defaults to the full catalog for that type.
 *
 * Backed by core-management's IpsecProposalController at /v3/ipsec-proposals.
 */
@HateoasResource('ipsec-proposals')
export class IpsecProposal extends Resource {
    id: string;
    type: 'IKE' | 'ESP';
    value: string; // e.g. "aes256gcm16-prfsha384-ecp384"
    label: string; // e.g. "AES-256-GCM, SHA-384, ECP-384 (recommended)"
    sortOrder: number; // 0-based, lower = higher preference
}
